import {css} from 'lit';

import {defaultStyles} from '../../../components/select.js';

export const styles = defaultStyles.extends({
  statics: css``,
  colorGen: () => '',
  sizeGen: () => '',
});

export default {styles};
